/**
 *  Component: Connector Line
 */
import React from 'react';

import styled from 'styled-components';

const ConnectorLine = () => (
  <Container>
    <Circle />
    <Line />
    <Circle />
  </Container>
);

const Container = styled.div`
  position: absolute;
  width: 80%;
  top: calc(50% + 4px);
  left: 50%;
  transform: translateX(-50%) translateY(-50%);
  margin-left: 4px;
  margin-right: 4px;
`;

const Circle = styled.div`
  border-radius: 50%;
  display: inline-block;
  background: #ccc;
  width: 8px;
  height: 8px;
`;

const Line = styled.div`
  display: inline-block;
  background: #ccc;
  height: 2px;
  width: calc(100% - 24px);
  margin-bottom: 3px;
`;

export default ConnectorLine;
